window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.expand = 750
window.lazySizesConfig.autoUnload = false
